module.exports = __webpack_public_path__ + "static/com_keeptruckin-4ec32c75f07588957df9158f5feff8a8.png";